import { API_URL } from "../config";
import { globalErrorHandler } from "../utils/errorHandler";

export const deleteLeave = async (leaveId: string, token: string) => {
  const res = await fetch(API_URL + `v1/leave/${leaveId}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  if (res.status === 401) {
    globalErrorHandler.handleError({
      response: { status: 401, statusText: res.statusText },
    });
  }

  if (!res.ok) {
    const body = await res.json().catch(() => null);
    throw new Error(body?.message || `İzin silinemedi: ${res.statusText}`);
  }
};

export const deleteLeaveApprovalProcess = async (
  leaveApprovalProcessId: string,
  token: string
) => {
  const res = await fetch(
    API_URL + `v1/leave-approval-process/${leaveApprovalProcessId}`,
    {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
  if (res.status === 401) {
    globalErrorHandler.handleError({
      response: { status: 401, statusText: res.statusText },
    });
  }

  if (!res.ok) {
    throw new Error(
      `Failed to delete leave approval process: ${res.statusText}`
    );
  }
};

export const deleteOvertimeApprovalProcess = async (
  overtimeApprovalProcessId: string,
  token: string
) => {
  const res = await fetch(
    API_URL + `v1/overtime-approval-process/${overtimeApprovalProcessId}`,
    {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );

  if (!res.ok) {
    throw new Error(
      `Failed to delete overtime approval process: ${res.statusText}`
    );
  }
};

export const deleteOvertime = async (overtimeId: string, token: string) => {
  const res = await fetch(API_URL + `v1/overtime/${overtimeId}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  if (res.status === 401) {
    globalErrorHandler.handleError({
      response: { status: 401, statusText: res.statusText },
    });
  }

  if (!res.ok) {
    throw new Error(`Failed to delete overtime: ${res.statusText}`);
  }
};

export const deleteUnit = async (
  unitId: string,
  token: string
): Promise<void> => {
  const res = await fetch(API_URL + `v1/unit/${unitId}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  if (res.status === 401) {
    globalErrorHandler.handleError({
      response: { status: 401, statusText: res.statusText },
    });
  }

  if (!res.ok) {
    throw new Error(`Failed to delete unit: ${res.statusText}`);
  }
};

export const deleteGate = async (
  gateId: string,
  token: string
): Promise<void> => {
  const res = await fetch(API_URL + `v1/gate/${gateId}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  if (res.status === 401) {
    globalErrorHandler.handleError({
      response: { status: 401, statusText: res.statusText },
    });
  }

  if (!res.ok) {
    throw new Error(`Failed to delete gate: ${res.statusText}`);
  }
};

export const deleteFactory = async (
  factoryId: string,
  token: string
): Promise<void> => {
  const res = await fetch(API_URL + `v1/factory/${factoryId}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  if (res.status === 401) {
    globalErrorHandler.handleError({
      response: { status: 401, statusText: res.statusText },
    });
  }

  if (!res.ok) {
    throw new Error(`Failed to delete factory: ${res.statusText}`);
  }
};

export const deleteWorkCalendar = async (
  workCalendarId: string,
  token: string
): Promise<void> => {
  const res = await fetch(API_URL + `v1/work-calendar/${workCalendarId}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  if (res.status === 401) {
    globalErrorHandler.handleError({
      response: { status: 401, statusText: res.statusText },
    });
  }

  if (!res.ok) {
    throw new Error(`Failed to delete work calendar: ${res.statusText}`);
  }
};

export const deleteLeaveType = async (
  leaveTypeId: string,
  token: string
): Promise<void> => {
  const res = await fetch(API_URL + `v1/leave-type/${leaveTypeId}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  if (res.status === 401) {
    globalErrorHandler.handleError({
      response: { status: 401, statusText: res.statusText },
    });
  }

  if (!res.ok) {
    throw new Error(`Failed to delete leave type: ${res.statusText}`);
  }
};

export const deleteRealm = async (
  realmId: string,
  token: string
): Promise<void> => {
  const res = await fetch(API_URL + `v1/realm/${realmId}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  if (res.status === 401) {
    globalErrorHandler.handleError({
      response: { status: 401, statusText: res.statusText },
    });
  }

  if (!res.ok) {
    throw new Error(`Failed to delete realm: ${res.statusText}`);
  }
};

export const deleteCalendarHoliday = async (
  holidayId: string,
  token: string
): Promise<void> => {
  const res = await fetch(API_URL + `v1/calendar-holidays/${holidayId}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  if (res.status === 401) {
    globalErrorHandler.handleError({
      response: { status: 401, statusText: res.statusText },
    });
  }

  if (!res.ok) {
    throw new Error(`Failed to delete calendar holiday: ${res.statusText}`);
  }
};

export const deleteFeatureFlag = async (
  flagId: string,
  token: string
): Promise<void> => {
  const res = await fetch(API_URL + `v1/feature-flag/${flagId}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  if (res.status === 401) {
    globalErrorHandler.handleError({
      response: { status: 401, statusText: res.statusText },
    });
  }

  if (!res.ok) {
    throw new Error(`Failed to delete feature flag: ${res.statusText}`);
  }
};

export const deleteLocation = async (
  locationId: string,
  token: string
): Promise<void> => {
  const res = await fetch(API_URL + `v1/locations/${locationId}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  if (res.status === 401) {
    globalErrorHandler.handleError({
      response: { status: 401, statusText: res.statusText },
    });
  }

  if (!res.ok) {
    // Backend hata mesajını kullanıcıya gösterebilmek için gövdeyi okuyoruz
    const body = await res.json().catch(() => null);
    throw new Error(body?.message || `Vardiya silinemedi: ${res.statusText}`);
  }
};
